// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1APXL","buttons":"styles_buttons__2PG_6"};